export enum EnvType {
  DEV = "DEV",
  PRD = "PRD",
  QUA = "QUA",
}

export const envType =
  {
    "dev.mynexity.fr": EnvType.DEV,
    "qua.mynexity.fr": EnvType.QUA,
  }[window.location.hostname.replace("www.", "")] ?? EnvType.PRD;
